@if (visible) {
  <div class="update-overlay" @overlayAnimation>
    <div class="update-overlay__backdrop"></div>

    <div class="update-overlay__modal" @modalAnimation role="dialog" aria-modal="true" aria-labelledby="update-title">
      <div class="update-header">
        <div class="update-header__icon" [class.update-header__icon--running]="updating">
          <div class="update-header__icon-glow"></div>
          <div class="update-header__icon-ring"></div>
          <i class="fa fa-cloud-download" aria-hidden="true"></i>
        </div>

        <h2 id="update-title" class="update-header__title">
          @if (!updating) {
            Nueva versión disponible
          } @else {
            Actualizando sistema
          }
        </h2>

        <p class="update-header__subtitle">
          @if (!updating) {
            Hemos publicado una actualización del sistema. Para continuar usándolo de forma segura, debes aplicarla ahora.
          } @else {
            Estamos preparando todo. No cierres esta ventana.
          }
        </p>

        @if (latestVersion?.version && !updating) {
          <span class="update-header__version">
            Versión: <strong>{{ latestVersion?.version }}</strong>
          </span>
        }
      </div>

      @if (updating) {
        <ul class="update-steps">
          @for (step of steps; track trackByStep($index, step)) {
            <li
              class="update-step"
              [class.update-step--active]="isStepActive(step.key)"
              [class.update-step--done]="isStepDone(step.key)"
            >
              <div class="update-step__indicator">
                @if (isStepDone(step.key)) {
                  <i class="fa fa-check" aria-hidden="true"></i>
                } @else if (isStepActive(step.key)) {
                  <span class="update-step__spinner" aria-hidden="true"></span>
                } @else {
                  <span class="update-step__dot" aria-hidden="true"></span>
                }
              </div>
              <div class="update-step__content">
                <span class="update-step__label">{{ step.label }}</span>
                <span class="update-step__description">{{ step.description }}</span>
              </div>
            </li>
          }
        </ul>
      } @else {
        <ul class="update-info">
          <li>
            <i class="fa fa-shield" aria-hidden="true"></i>
            <span>Tu sesión se cerrará por seguridad.</span>
          </li>
          <li>
            <i class="fa fa-refresh" aria-hidden="true"></i>
            <span>Se recargará automáticamente la página.</span>
          </li>
          <li>
            <i class="fa fa-bolt" aria-hidden="true"></i>
            <span>Todo el proceso toma unos segundos.</span>
          </li>
        </ul>
      }

      <button
        type="button"
        class="update-button"
        [class.update-button--loading]="updating"
        [disabled]="updating"
        (click)="applyUpdate()"
      >
        @if (!updating) {
          <i class="fa fa-rocket" aria-hidden="true"></i>
          <span>Actualizar sistema y cerrar sesión</span>
        } @else {
          <span class="update-button__spinner" aria-hidden="true"></span>
          <span>Actualizando…</span>
        }
      </button>

      @if (!updating) {
        <p class="update-overlay__hint">
          Esta actualización es obligatoria. Recargar o cerrar la pestaña volverá a mostrar esta pantalla.
        </p>
      }
    </div>
  </div>
}
